import hasWebp from 'check-for-webp';

/**
 * replace known images formats for webp if availble
 *
 */
const convertToWebP = url => (hasWebp ? url.replace(/(.jpg|.jpeg|.png|.gif)/, '.webp') : url);

export default convertToWebP;
